export enum OTP_CONSTANTS {
    MODULE_NAME = 'msisdn-selfService',
    FIELD_TYPE = 'msisdn'
}